var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.33203C14.25 6.07225 13.7496 4.86407 12.8588 3.97327C11.968 3.08248 10.7598 2.58203 9.5 2.58203C8.24022 2.58203 7.03204 3.08248 6.14124 3.97327C5.25045 4.86407 4.75 6.07225 4.75 7.33203C4.75 12.8737 2.375 14.457 2.375 14.457H16.625C16.625 14.457 14.25 12.8737 14.25 7.33203Z",
    stroke: "#7A49B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8695 17.625C10.7304 17.8649 10.5306 18.0641 10.2902 18.2025C10.0499 18.341 9.77734 18.4139 9.49995 18.4139C9.22257 18.4139 8.95005 18.341 8.70969 18.2025C8.46933 18.0641 8.26955 17.8649 8.13037 17.625",
    stroke: "#7A49B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ced315e6.svg";
export { ForwardRef as ReactComponent };